import React, { useEffect, useState } from 'react'
import { DocWithPreview } from '../../Common/DocWithPreview'
import { Box, Checkbox, FormControlLabel, Grid, ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material'
import TextLabel from '../../Common/CommonTextLabel'
import { makeStyles } from 'tss-react/mui';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { BucketURL } from '../../../ApiSetup/Api';
import CommonTextField from '../../Common/CommonTextField';
import dayjs from 'dayjs'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CommonTextArea from '../CommonTextArea';
import ButtonOutlined from '../../Common/ButtonOutlined';
import ButtonContained from '../../Common/ButtonContained';
import CommonCheckBox from '../CommonCheckBox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { checkAccess, getImageUrl } from '../../../Utils/handler';
import { useSelector } from 'react-redux';
import { showLoader } from '../../../Redux/Slices/loaderSlice';
import { getAvailableAccess } from '../../../Redux/Actions/action';
import CommonDropDown from '../../Common/CommonDropDown';
import { addressProofTypes } from '../../../Utils/enum';
import ReUploadModal from '../../Common/ReUploadModal';
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';
import sessionStoreUtil from '../../../ApiSetup/Localstorage';

const useStyles = makeStyles()((theme) => {

    return {
        gridBorder: {
            background: theme.palette.secondary.main,
            border: `2px dashed ${theme.palette.bgLightBlack.main}`,
            padding: "10px", // Default value
            borderRadius: "12px",
        },
    }
})
const AddressProof = ({ data, isEdit, setIsEdit, setImagePreView, handleStatusChange, setData, handleInputChange, setValue, handleChange, errors, dataAccess, handleUpload, openAddressProof,
    setOpenAddressProof, document }) => {


    const theme = useTheme()
    const { pathname } = useLocation();
    const startPathname = pathname?.split('-')[0];
    const user = sessionStoreUtil.getLSItem("userData")
        ? JSON.parse(sessionStoreUtil.getLSItem("userData"))
        : {};

    // const dataAccess = useSelector(value => value?.allAvailableAccess?.AllAvailableAccessList)

    // // -------- useEffect ----------
    // useEffect(() => {
    //     dispatch(showLoader(true));
    //     dispatch(getAvailableAccess())
    //         .unwrap() // Automatically handles async response
    //         .catch((error) => console.error("error", error))
    //         .finally(() => dispatch(showLoader(false)));
    // }, [dispatch]);

    return (
        <>
            <Grid container spacing={2} item xs={12} sm={12}>

                <Grid item xs={12} padding={'2px 15px !important'}>
                    <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"Verify Address Proof"} />
                </Grid>
                <Grid item sm={12} xs={12}>

                    <Box onClick={() => setImagePreView({ isOpen: true, link: getImageUrl(document?.addressProofDetails?.uploadAddressProof?.[0]) })}>
                        <DocWithPreview
                            docArray={document?.addressProofDetails?.uploadAddressProof?.length > 0 ? document?.addressProofDetails?.uploadAddressProof : []}
                            docName={"Address Proof"}
                            title={"Address Proof"}
                        />
                        {((checkAccess(startPathname, dataAccess, 'Reupload Button')) && isEdit.addressProof) &&
                            <ButtonOutlined
                                startIcon={<CloudSyncOutlinedIcon />}
                                border={"none"}
                                width={"auto"}
                                text={"Reupload"}
                                padding={{ xs: "5px 10px", md: "5px 10px" }}
                                fontSize={{ xs: "12px", md: "14px" }}
                                height={{ xs: "30px", sm: "30px" }}
                                onClick={() => { setOpenAddressProof(true) }}
                            />}
                    </Box>
                </Grid>

                <Grid container spacing={1} >
                    <Grid item xs={12} sm={12}>
                        <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'} >
                            {checkAccess(startPathname, dataAccess, 'Accept/Reject Action') && data?.verificationStatus !== "Approved" &&
                                <Box display={'flex'} alignItems={'center'} gap={1}>
                                    <ToggleButtonGroup
                                        color={data?.addressProof?.status == "Approved" ? "success" : "error"}
                                        value={data?.addressProof?.status}
                                        exclusive
                                        aria-label="Platform"
                                        size='small'
                                    >
                                        <ToggleButton sx={{ borderRadius: '20px', width: '100px', fontWeight: 550 }} value="Approved" onClick={() => handleStatusChange("status", "addressProof", "Approved")}>
                                            {data?.addressProof?.status == "Approved" ? "Approved" : "Approve"}</ToggleButton>
                                        <ToggleButton sx={{ borderRadius: '20px', width: '100px', fontWeight: 550 }} value="Rejected" onClick={() => handleStatusChange("status", "addressProof", "Rejected")}>
                                            {data?.addressProof?.status == "Rejected" ? "Rejected" : "Reject"}</ToggleButton>
                                    </ToggleButtonGroup>
                                </Box>
                            }
                            {checkAccess(startPathname, dataAccess, 'Accept/Reject Action') &&
                                data?.verificationStatus == "Approved" && <ButtonOutlined
                                    width={"auto"}
                                    text={"Approved"}
                                    border={"1px dashed green"}
                                    color={'green'}
                                    borderRadius={'20px'}
                                    padding={{ xs: "5px 10px", md: "5px 10px" }}
                                    fontSize={{ xs: "12px", md: "14px" }}
                                    height={{ xs: "30px", sm: "30px", md: "30px" }}
                                    endIcon={<CheckCircleIcon />}
                                />}
                        </Box>

                    </Grid>
                    {data?.verificationStatus !== "Approved" && data?.addressProof?.status == "Rejected" &&
                        <Grid item xs={12}>      
                         <CommonTextArea
                            label="Reason"
                            value={data?.addressProof?.reason}
                            labelSize={{ lg: "14px", md: "14px", xs: "12px" }}
                            name='reason'
                            onChange={(e) => handleInputChange(e, "addressProof")}
                            rows={2}
                            disabled={user?.organisationName !== "PPSK"}
                        />
                        </Grid>
                    }
                </Grid>

                {
                    openAddressProof &&
                    <ReUploadModal
                        multiple
                        open={openAddressProof}
                        handleClose={() => setOpenAddressProof(false)}
                        onSave={() => setOpenAddressProof(false)}
                        text={"Address Proof (સરનામાનો પુરાવો)"}
                        name={"addressProofFile"}
                        onChange={(e) => handleUpload(e, "uploadDocuments", "addressProof")}
                        imageValue={data?.uploadDocuments?.addressProof?.addressProofFile}
                    />
                }
            </Grid>
        </>
    )
}

export default AddressProof
